/**
* @ngdoc component
* @name common.address.component:itxAddressLines
* @description
* Component description
*/
(function() {
    'use strict';

    var itxAddressLines = {
        bindings: {
            model:'=',
            form:'=',
            countryCode:'<',
            completeInfo: '=',
            showMap:'<',
            isKorea:'<',
            isSpain: '<',
            isQatar: '<',
            isChina: '<',
            isNetherlands: '<',
            isBelgium: '<',
            isLuxembourg: '<',
            validationEnabled: '<',
            showAutocomplete:'<',
            onTyping:'&'
        },
        controller:   itxAddressLinesCtrl,
        templateUrl: 'address-lines.component.html'
    };

    itxAddressLinesCtrl.$inject = [
        '$scope',
        'AddressService',
        'MapService',
        'ItxTranslateSvc',
        'CountryService',
        'crmService',
        'DUTTI_CONS',
        'CmsConfigSvc',
        'MdFeelMyAccountService'
    ];

    function itxAddressLinesCtrl (
        $scope,
        AddressService,
        MapService,
        ItxTranslateSvc,
        CountryService,
        crmService,
        DUTTI_CONS,
        CmsConfigSvc,
        MdFeelMyAccountService
    ) {
        var _this = this;
        _this.hideAddress1 = false;
        _this.systemPointsEnabled = false;
        _this.hasNumber = false;
        _this.is200enabled = false;
        
        _this.$onInit = function () {
            if(_this.isQatar) {
                _this.hideAddress1 = true;
                _this.classAdressLine2 = 'col-sm-12';

            }

            _this.is360 = crmService.is360();
            _this.isBaidu = inditex.iStoreJSON.countryCode === 'CN' && inditex.iBaiduMapsKey;
            _this.addressRequiresNumber = _this.isNetherlands || _this.isBelgium || _this.isLuxembourg;
            inditex.initMaps = _this.isBaidu ? inditex.initBaiduMaps : inditex.initGoogleMaps;
            _this.isColombia = CountryService.is(DUTTI_CONS.country.CO);

            _this.validateAddressLine();

            MapService.initMap(_this.isBaidu)
                .then(function(map) {

                });

            // Comprobacion del estado del sistema de puntos
            CmsConfigSvc.getProperty('feel_points_program_enabled').then(function (systemPointsEnabled) {
                if (systemPointsEnabled) {
                    _this.systemPointsEnabled = true;
                }
            });

            MdFeelMyAccountService.check200PointsEnabled().then(function (isEnabled) {
                _this.is200enabled = true;
            });
        };

        _this.addAutocompleteToInput = function(input, model) {
            
            inditex.iGooglePlacesEnabled = true;
            var options = {
                types: ['geocode'],
                componentRestrictions: {
                    country: inditex.iCountryCode !== 'IC' ? inditex.iCountryCode : 'ES'
                }
            };

            _this.autocomplete = inditex.autocomplete(input, _this.GOOGLE_MAPS_REQUEST, _this.GOOGLE_MAPS_LIBRARY, options);
            //FIXME: Core library does not permit two autocompletes in same page (uses the same event)
            if (_this.autocomplete) {
                _this.autocomplete.addListener('place_changed', function() {

                    _this.autocomplete.getPlace(function(place) {
                        
                        // Esto es lo que actualiza el mapa con la nueva direccion.
                        if (_this.showMap && inditex.populateMap) {
                            inditex.populateMap(place.geometry.location.lat(), place.geometry.location.lng());
                        }

                        $scope.$apply(function() {
                            if (!!place && !!place.address_components) {
                                var addressArray = AddressService.prepareAddress(place,_this.countryCode);

                                model.addressLines[0] = _this.getFullAddress(addressArray);
                                model.zipCode = addressArray['postalCode'] || '';
                                model.city = addressArray['city'] || '';
                                model.municipality = addressArray['municipality'];
                                model.colony = addressArray['colony'];

                                $('.pac-container.pac-logo').remove();

                                // States
                                if (inditex.iStoreJSON.details.hideProvinceCombo !== '1') {
                                    _this.onTyping({addressArray: addressArray, model: model});
                                }
                            }
                        });
                    });
                });
            }
        };

        _this.getFullAddress = function(addressArray) {
            var address = (addressArray['address'] || '');
            if (addressArray['number']) {
                address += ', ' + addressArray['number'];
            }
            if (address === '') {
                address = (addressArray['city'] || '');
            }
            if (address === '') {
                address = (addressArray['country'] || '');
            }
            return address;
        };

        _this.validateAddressLine = function(){
            _this.hasNumber = /\d/.test(_this.model.addressLines[0]);
        }
    }

    angular.module('itxApp.legacy')
    .component('itxAddressLines',itxAddressLines);

})();
